import { Icon } from '@modulor/react';
import Image from '../Image/Image';
import {
  getCategoryDetailRoute,
  getProviderDetailsRoute,
} from '../../utils/routes';
import {
  getCategoryImagePath,
  getGameProviderImagePath,
} from '../../utils/imagePath';
import { EVENT_ACTION } from '../../constants/ga';
import { ANALYTICS_SCREEN_AREA_DETAILS } from '../../constants/analytics';

const Fallback = (
  <Icon
    name="no_icon"
    style={{
      width: '100%',
      height: '100%',
    }}
  />
);
export const providerToNavItemAdapter = (
  { imagePath, id, translationKey, gameCount },
  path,
  isDesktop
) => ({
  translationKey,
  link: getProviderDetailsRoute(id),
  eventAction: EVENT_ACTION.FILTER_PROVIDER,
  id,
  count: gameCount,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.PROVIDER,
  IconComponent: () => (
    <Image
      fallback={Fallback}
      src={getGameProviderImagePath(path, id, isDesktop)}
    />
  ),
});

export const categoryToNavItemAdapter = (
  { imagePath, id, translationKey, gameCount },
  path,
  isDesktop
) => ({
  translationKey,
  link: getCategoryDetailRoute(id),
  eventAction: EVENT_ACTION.FILTER_CATEGORY,
  id,
  count: gameCount,
  analyticAreaDetail: ANALYTICS_SCREEN_AREA_DETAILS.CATEGORY,
  IconComponent: () => (
    <Image
      fallback={Fallback}
      src={getCategoryImagePath(path, id, isDesktop)}
    />
  ),
});
